import React from "react";

// Decorative retro pixel-art scene for the "Why Us" section:
// a circuit board with current flowing along traces, pulsing chip
// nodes, and a chain of "blocks" lighting in sequence — tying to
// scalable architecture + AI/blockchain fluency.
// Palette matches the site's ink/gold/green brand tokens.
const TRACES = [
  "M16 40 H110 V92 H188",
  "M254 28 H170 V116 H86 V160",
  "M28 176 H120 V120 H214 V56",
];

const NODES = [
  { x: 8, y: 30 },
  { x: 180, y: 82 },
  { x: 244, y: 18 },
  { x: 206, y: 46 },
  { x: 36, y: 92 },
];

const BLOCKS = [0, 1, 2, 3].map((i) => ({ i, x: 34 + i * 56 }));

const PixelCircuitScene = () => (
  <svg
    className="pixel-scene pixel-scene--circuit"
    viewBox="0 0 270 200"
    role="img"
    aria-label="Pixel-art animation of a circuit board with flowing current and a chain of linked blocks"
    preserveAspectRatio="xMidYMid meet"
  >
    {/* board */}
    <rect x="0" y="0" width="270" height="200" fill="#1D1712" />
    <rect
      x="6"
      y="6"
      width="258"
      height="188"
      fill="none"
      stroke="#3A3027"
      strokeWidth="2"
    />

    {/* faint board grid */}
    {Array.from({ length: 8 }).map((_, gx) =>
      Array.from({ length: 6 }).map((__, gy) => (
        <rect
          key={`${gx}-${gy}`}
          x={20 + gx * 30}
          y={20 + gy * 28}
          width="2"
          height="2"
          fill="#2A221A"
        />
      ))
    )}

    {/* traces: dim base + bright flowing pulse */}
    {TRACES.map((d, i) => (
      <g key={i}>
        <path d={d} fill="none" stroke="#4A4036" strokeWidth="4" />
        <path
          className="pixel-flow"
          d={d}
          fill="none"
          stroke="#E8A70F"
          strokeWidth="4"
          style={{ animationDelay: `${i * 0.7}s` }}
        />
      </g>
    ))}

    {/* pulsing chip nodes */}
    {NODES.map((n, i) => (
      <g key={i}>
        <rect
          x={n.x}
          y={n.y}
          width="18"
          height="18"
          fill="#2A221A"
          stroke="#E8A70F"
          strokeWidth="2"
        />
        <rect x={n.x - 4} y={n.y + 5} width="4" height="3" fill="#4A4036" />
        <rect x={n.x + 18} y={n.y + 5} width="4" height="3" fill="#4A4036" />
        <rect
          className="pixel-node"
          x={n.x + 4}
          y={n.y + 4}
          width="10"
          height="10"
          fill="#F2C14E"
          style={{ animationDelay: `${i * 0.3}s` }}
        />
      </g>
    ))}

    {/* blockchain: linked blocks lighting in sequence */}
    {[0, 1, 2].map((i) => (
      <rect
        key={`link-${i}`}
        x={64 + i * 56}
        y="164"
        width="22"
        height="6"
        fill="#4E9E3C"
      />
    ))}
    {BLOCKS.map(({ i, x }) => (
      <g key={`block-${i}`}>
        <rect
          className="pixel-block"
          x={x}
          y="150"
          width="34"
          height="34"
          fill="#2A221A"
          stroke="#4E9E3C"
          strokeWidth="2"
          style={{ animationDelay: `${i * 0.8}s` }}
        />
        <rect x={x + 6} y="158" width="22" height="3" fill="#1D1712" />
        <rect x={x + 6} y="166" width="14" height="3" fill="#1D1712" />
        <rect x={x + 6} y="174" width="18" height="3" fill="#1D1712" />
      </g>
    ))}

    {/* blinking terminal caret */}
    <rect x="16" y="16" width="14" height="4" fill="#4E9E3C" />
    <rect
      className="pixel-caret"
      x="34"
      y="16"
      width="8"
      height="4"
      fill="#4E9E3C"
    />
  </svg>
);

export default PixelCircuitScene;
